import { memo } from "react";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { useUser } from "@hooks/useUser";
import { ActorIcon } from "../../components/ActorIcon";
import { ActorName } from "../../components/ActorName";
import { useVisibleHistoryChannel } from "../../hooks/useVisibleHistoryChannel";
import {
    resolveActorChannelLabel,
    resolveActorDisplayName,
} from "../../utils/actorUtils";
import { HistoryRow } from "../historyViewConfig";
import styles from "./Cell.module.scss";

export const UpdatedByCell = memo(
    ({ row }: CellContext<ViewTableFeatures, HistoryRow, number | null>) => {
        const currentUser = useUser();
        const {
            actorType,
            actorName,
            actorId,
            sourceType,
            member,
            fields,
            changeTypes,
            system,
            channel,
        } = row.original;
        const visibleChannel = useVisibleHistoryChannel(channel);

        const actorParams = {
            actorType,
            actorName,
            sourceType,
            fields,
            changeTypes,
            system,
            currentUserId: currentUser?.id,
            actorId,
            memberName: member?.user?.preferredName,
        };

        return (
            <ViewTableCell className={styles.updatedByCell}>
                <ActorIcon
                    actorType={actorType}
                    actorName={actorName}
                    sourceType={sourceType}
                    user={member?.user}
                    fields={fields}
                    changeTypes={changeTypes}
                    system={system}
                />
                <ActorName
                    name={resolveActorDisplayName(actorParams)}
                    channelLabel={resolveActorChannelLabel({
                        ...actorParams,
                        channel: visibleChannel,
                    })}
                />
            </ViewTableCell>
        );
    },
);

UpdatedByCell.displayName = "UpdatedByCell";
